const getRelationalResource = (relation, relationalResourceId) => ({
  [relation.key]: relation.getResourceById(relationalResourceId),
});

export const defaultResourceSelector = ({ main, relations = [] }) => {
  const resource = main.getResourceById(main.resourceId);
  const resourceClone = { ...resource };
  delete resourceClone?.custom;

  if (resource.custom) {
    return {
      ...resourceClone,
      ...resource.custom,
      isDefault: false,
      default: {
        ...resourceClone,
        ...relations.reduce(
          (acc, relation) => ({
            ...acc,
            ...getRelationalResource(relation, resource[relation.key].id),
          }),
          {}
        ),
      },
      ...relations.reduce(
        (acc, relation) => ({
          ...acc,
          ...getRelationalResource(
            relation,
            resource.custom[`${relation.key}Id`]
          ),
        }),
        {}
      ),
    };
  }

  return {
    ...resourceClone,
    ...relations.reduce(
      (acc, relation) => ({
        ...acc,
        ...getRelationalResource(relation, resource[relation.key].id),
      }),
      {}
    ),
  };
};

export const currentWorkspaceResourceById =
  (state, adapterSelector) => (id) => {
    const resource = adapterSelector.selectById(state, id);
    if (!resource) return null;
    const resourceClone = { ...resource };
    delete resourceClone?.custom;
    if (resource.custom) {
      return {
        ...resourceClone,
        ...resource.custom,
        default: resourceClone,
        isDefault: false,
      };
    }

    return resourceClone;
  };

// formato

// {
//   main: {
//     resourceId,
//     getResourceById,
//   },
//   relations: [
//     {
//       key: '',
//       getResourceById: ''
//     }
//   ]
// }
